import { createSelector, createFeatureSelector } from '@ngrx/store';
import { buildListMessage } from 'src/admin-app/utilities/list-filtering/list-message';
import {
	CustomerUsersState,
	customerUsersFeatureKey,
	customerUserAdapter,
} from './customer-users.reducer';

const getCustomerUsersState = createFeatureSelector<CustomerUsersState>(
	customerUsersFeatureKey
);

const { selectEntities } = customerUserAdapter.getSelectors();

export const getListLoadingStatus = createSelector(
	getCustomerUsersState,
	(state) => !state.isListInitialized || state.isListLoading
);

export const getRegistrationRequestListLoadingStatus = createSelector(
	getCustomerUsersState,
	(state) =>
		!state.isRegistrationRequestListInitialized ||
		state.isRegistrationRequestListLoading
);

export const getListMessage = createSelector(
	getCustomerUsersState,
	getListLoadingStatus,
	(state, isLoading) =>
		buildListMessage(state.error, isLoading, state.pagedResults)
);

export const getRegistrationRequestListMessage = createSelector(
	getCustomerUsersState,
	getRegistrationRequestListLoadingStatus,
	(state, isLoading) =>
		buildListMessage(
			state.error,
			isLoading,
			state.registrationRequestPagedResults
		)
);

export const getFilteredAndPagedCustomerUsers = createSelector(
	getCustomerUsersState,
	(state) => (state.pagedResults ? state.pagedResults.results : [])
);

export const getFilteredAndPagedRegistrationRequests = createSelector(
	getCustomerUsersState,
	(state) =>
		state.registrationRequestPagedResults
			? state.registrationRequestPagedResults.results
			: []
);

export const getPagedCustomerUsersCount = createSelector(
	getCustomerUsersState,
	(state) => (state.pagedResults ? state.pagedResults.resultCount : 0)
);

export const getPagedRegistrationRequestsCount = createSelector(
	getCustomerUsersState,
	(state) =>
		state.registrationRequestPagedResults
			? state.registrationRequestPagedResults.resultCount
			: 0
);

export const getListArgs = createSelector(
	getCustomerUsersState,
	(state) => state.listArgs
);

export const getDetailLoadingStatus = createSelector(
	getCustomerUsersState,
	(state) => !!state.isDetailLoading
);

export const getTitle = createSelector(getCustomerUsersState, (state) =>
	state.selectedUserId ? 'Edit User' : 'Add User'
);

export const getSelectedCustomerUsersId = createSelector(
	getCustomerUsersState,
	(state) => state.selectedUserId
);

export const getAllCustomerUsersEntities = createSelector(
	getCustomerUsersState,
	selectEntities
);

export const getSelectedCustomerUser = createSelector(
	getAllCustomerUsersEntities,
	getSelectedCustomerUsersId,
	(userEntities, userId) => userEntities[userId]
);

export const getCustomerUsersEntity = (id: number) =>
	createSelector(getAllCustomerUsersEntities, (entities) => entities[id]);

export const getCloseAfterSaving = createSelector(
	getCustomerUsersState,
	(state) => !state.shouldStayOnPage
);

export const getIsSaving = createSelector(
	getCustomerUsersState,
	(state) => state.isSaving
);

export const getError = createSelector(
	getCustomerUsersState,
	(state) => state.error
);

export const getShouldSaveButtonShake = createSelector(
	getCustomerUsersState,
	(state) => state.error && !state.shouldStayOnPage
);
